import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { ROLES } from './constants';
import roleApiSlice from 'src/features/role-api-slice';

export const store = configureStore({
  reducer: {
    [ROLES]: roleApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(roleApiSlice.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
